import React, { useState } from "react";
import image from "../../../assets/images/EN_Aboutus.png";
import imageAr from "../../../assets/images/AR_AboutUs.png";
import { GetAppText } from "../../../utils";
import { useSelector } from "react-redux";
import { apiRoutes } from "../../../apis/routes";
import { postRequest } from "../../../apis/methods";
import { InputComponent } from "../../components/InputComponent";
import { ButtonComponent } from "../../components/ButtonComponent";
import { AlertComponent } from "../../components/AlertComponent";
import { handleSuccess } from "../../components/Toast/toastHelper";
import { ToastContainer } from "react-toastify";

const initialForm = {
  name: "",
  email: "",
  phone: "",
  subject: "",
  message: "",
};

const ContactUs = () => {
  const language = useSelector((state) => state.language.value);
  const textAlignStyle = language === "_ar" ? "right" : "left";
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState("");

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const getErrorMessage = (response) => {
    const errors = response?.data?.errors;
    if (errors) {
      const firstKey = Object.keys(errors)[0];
      const firstError = errors[firstKey];
      if (Array.isArray(firstError) && firstError[0]) {
        return firstError[0];
      }
    }
    if (typeof response?.data?.message === "string") {
      return response.data.message.replace(/-/g, " ");
    }
    if (typeof response?.message === "string") {
      return response.message.replace(/-/g, " ");
    }
    return GetAppText("something_went_wrong");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const name = form.name.trim();
    const email = form.email.trim();
    const phone = form.phone.trim();
    const subject = form.subject.trim();
    const message = form.message.trim();

    if (!name || !email || !subject || !message) {
      setAlert(GetAppText("fields_req"));
      setTimeout(() => setAlert(""), 2000);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setAlert(GetAppText("email_must_be_valid"));
      setTimeout(() => setAlert(""), 2000);
      return;
    }

    const payload = {
      name,
      email,
      phone: phone || null,
      subject,
      message,
    };

    setLoading(true);
    try {
      const response = await postRequest(apiRoutes.contact, payload);
      if (response.status === "success") {
        setLoading(false);
        setForm(initialForm);
        setAlert("");
        handleSuccess(GetAppText("contact_success"), language);
      } else {
        setAlert(getErrorMessage(response));
        setTimeout(() => setAlert(""), 3000);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      setAlert(GetAppText("something_went_wrong"));
      setTimeout(() => setAlert(""), 3000);
    }
  };

  return (
    <div className="space-y-4">
      <ToastContainer />
      <div className="relative bg-secondary_green overflow-hidden">
        <img
          src={language === "_ar" ? imageAr : image}
          className="relative w-full lg:object-fill object-cover"
          alt=""
        />
        <div
          className={`absolute top-0 z-20 pointer-events-none ${
            language === "_ar" ? "right-0" : "left-0"
          }`}
        >
          <img
            className={`object-cover opacity-60 ${
              language === "_en" ? "-scale-x-100" : ""
            }`}
            src={require("../../../assets/images/Vector3.png")}
            alt=""
          />
        </div>
        <div
          className={`flex items-center z-40 lg:bottom-20 sm:bottom-10 bottom-4 absolute ${
            language === "_ar"
              ? "flex-row-reverse md:right-20 sm:right-10 right-5"
              : "md:left-20 sm:left-10 left-5"
          } text-white sm:text-F40 text-[28px] font-bold drop-shadow-md`}
        >
          {GetAppText("contact_us")}
        </div>
      </div>
      <div className="site-container site-container--narrow md:py-16 py-8 space-y-6">
        <h1
          className={`flex items-center  ${
            language === "_ar" ? "flex-row-reverse " : ""
          } text-primary text-F24 font-bold `}
        >
          {GetAppText("contact_us")}
        </h1>
        <form
          onSubmit={handleSubmit}
          className="bg-white p-6 rounded-xl space-y-6"
        >
          <div
            className={`md:flex items-start md:space-x-4 md:space-y-0 space-y-5 ${
              language === "_ar" ? "flex-row-reverse md:space-x-reverse" : ""
            }`}
          >
            <div className="space-y-2 w-full">
              <span
                className="text-black text-F14 block"
                style={{ textAlign: textAlignStyle }}
              >
                {GetAppText("name")}
              </span>
              <InputComponent
                input_style={"!py-3"}
                name="name"
                value={form.name}
                onChange={handleChange("name")}
                maxLength={255}
              />
            </div>
            <div className="space-y-2 w-full">
              <span
                className="text-black text-F14 block"
                style={{ textAlign: textAlignStyle }}
              >
                {GetAppText("email")}
              </span>
              <InputComponent
                input_style={"!py-3"}
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange("email")}
                maxLength={255}
              />
            </div>
          </div>
          <div
            className={`md:flex items-start md:space-x-4 md:space-y-0 space-y-5 ${
              language === "_ar" ? "flex-row-reverse md:space-x-reverse" : ""
            }`}
          >
            <div className="space-y-2 w-full">
              <span
                className="text-black text-F14 block"
                style={{ textAlign: textAlignStyle }}
              >
                {GetAppText("phone")}
              </span>
              <InputComponent
                input_style={"!py-3"}
                name="phone"
                value={form.phone}
                onChange={handleChange("phone")}
                maxLength={30}
              />
            </div>
            <div className="space-y-2 w-full">
              <span
                className="text-black text-F14 block"
                style={{ textAlign: textAlignStyle }}
              >
                {GetAppText("subject")}
              </span>
              <InputComponent
                input_style={"!py-3"}
                name="subject"
                value={form.subject}
                onChange={handleChange("subject")}
                maxLength={255}
              />
            </div>
          </div>
          <div className="space-y-2 w-full">
            <span
              className="text-black text-F14 block"
              style={{ textAlign: textAlignStyle }}
            >
              {GetAppText("message")}
            </span>
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange("message")}
              maxLength={5000}
              rows={6}
              className={`block w-full py-3 placeholder:text-F14 text-sm placeholder:text-lightTextColor focus:outline-none focus:border-borderColor focus:ring-0 border-2 border-borderColor rounded-lg ${
                language === "_ar" ? "pe-2 text-right" : "ps-3"
              }`}
            />
          </div>
          {alert && (
            <AlertComponent
              text={alert}
              isArb={false}
              svgName={"Warning"}
              svgColor={"#E94747"}
              styles={"!text-errorColor !bg-alertErrorBg"}
            />
          )}
          <div
            className={`md:flex w-full ${
              language === "_en" ? "justify-end" : ""
            }`}
          >
            <div className="md:w-fit w-full">
              <ButtonComponent
                loading={loading}
                disabled={loading}
                type="secondary"
                title={GetAppText("send")}
                styles={"!text-F18 !w-full !px-6"}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
